import EventNoteIcon from "@mui/icons-material/EventNote";
import permissions from "app/permissions";
import { PREPARATORY_CLASSES, StudentServicePath } from "utils/constants";
import ListPreparatoryClasses from "./List";

export const resources = {
  isMenu: true,
  icon: <EventNoteIcon />,
  name: StudentServicePath + PREPARATORY_CLASSES,
  title: "Занятия подготвителна година",
  list: <ListPreparatoryClasses />,
  permission: permissions.canPreviewPreparatoryClasses,
};
